var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"systemTable"},[_c('a-table',{attrs:{"loading":_vm.loading,"dataSource":_vm.dataSource,"columns":_vm.columns,"pagination":_vm.paginationProps},on:{"change":_vm.handleTableChange}},[_vm._v(" //分页属性 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }